import { createAsyncThunk } from '@reduxjs/toolkit';

export const onToggleUploadModal = createAsyncThunk(
  'onToggleUploadModal',
  async (
    data: { action: boolean },
    { dispatch, extra, getState }: { dispatch: any; extra: any; getState: any }
  ) => {
    if (data.action !== null) {
      return { action: data.action };
    } else {
      return;
    }
  }
);

export default onToggleUploadModal;
